import React from 'react';
const ShopGuide: React.FC = () => (
  <div className="min-h-screen bg-white py-12" dir="ltr">
    <div className="max-w-3xl mx-auto bg-purple-50 rounded-xl shadow-lg p-8">
      <h1 className="text-3xl font-bold text-purple-900 mb-6">Shopping & Bazaars in Iran</h1>
      <p className="text-lg text-gray-700 mb-4">Learn about shopping, bargaining, and finding the best souvenirs in Iran's vibrant bazaars.</p>
      {/* Add more content here */}
    </div>
  </div>
);
export default ShopGuide; 